import { CmsSchemas, useCmsApi } from './useCmsApi';

// Re-export codegen'd shapes so call sites can keep their existing imports.
// These are auto-generated from the CMS server's OpenAPI schema — if you
// change a Jira DTO on the server, run `pnpm codegen` and the types here
// update for free.
export type JiraIssueSummary = CmsSchemas['JiraIssueSummary'];
export type JiraSubtask = CmsSchemas['JiraSubtask'];
export type JiraAttachment = CmsSchemas['JiraAttachment'];
export type JiraComment = CmsSchemas['JiraComment'];

/**
 * openapi-react-query keys queries by `[method, path]`. Expose the search
 * key here so components can invalidate all Jira issue searches without
 * hard-coding the tuple in multiple places.
 */
export const JIRA_QUERY_KEYS = {
    searchAll: ['get', '/api/gift-jira/v1/issues'] as const,
};

export const useJiraConfig = () => {
    const $api = useCmsApi();
    return $api.useQuery('get', '/api/gift-jira/v1/config', undefined, {
        staleTime: 5 * 60 * 1000,
    });
};

export const useCreateJiraIssue = () => {
    const $api = useCmsApi();
    return $api.useMutation('post', '/api/gift-jira/v1/issues');
};

export const useCreateJiraSubtask = () => {
    const $api = useCmsApi();
    return $api.useMutation(
        'post',
        '/api/gift-jira/v1/issues/{parentKey}/subtasks',
    );
};

export const useUpdateJiraSubtask = () => {
    const $api = useCmsApi();
    return $api.useMutation('put', '/api/gift-jira/v1/issues/{issueKey}');
};

export const useJiraIssues = (status: 'open' | 'done') => {
    const $api = useCmsApi();
    return $api.useQuery('get', '/api/gift-jira/v1/issues', {
        params: { query: { status } },
    });
};
